import { frontendURL } from '../../../helper/URLHelper';
const CatalogoView = () => import('./CatalogoView.vue');

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/catalogo'),
      name: 'catalogo_view',
      component: CatalogoView,
      meta: { permissions: ['administrator', 'agent'] },
    },
  ],
};
